import { ref } from 'vue';

const getProjectsOpen = () => {
    const projectOpen_error = ref(null);
    const projectsOpen = ref(null);

    const loadProjectsOpen = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        
        try {
            let data = await fetch("/api/projectsopen?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            projectsOpen.value = await data.json();
            //console.log(projectsOpen.value);
        } catch (err) {
            projectOpen_error.value = err.message;
        }
    };

    const closeProjectOpen = async (projectOpen) => {
     
        const id = projectOpen.id;

        const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
          });
          const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json',
                "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify(projectOpen)
        };

        try {
            const response = await fetch('/api/stamps/' + id, requestOptions);
            //console.log(requestOptions);
            const data = await response.json();

            if (!response.ok) {
                //console.log(response.status + ' - ' + response.statusText);
                projectOpen_error.value =  data.message;
                console.log(projectOpen_error.value);
            }

        } catch (err) {
            projectOpen_error.value = err.message;
            console.log( err.message);
        }
    };
     
    return { projectsOpen, projectOpen_error, loadProjectsOpen, closeProjectOpen};
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getProjectsOpen;
